import React, { Fragment, Component } from 'react';
import spinnerIcon from '../../img/spinner.svg';

class SearchCarNumber extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount = () => {
    this.props.addToDataLayer();
  }

  componentDidUpdate = (prevProps) => {
    if (prevProps.step !== 1 && this.props.step === 1) {
      this.props.addToDataLayer();
    }
  }

  clickHandler = () => {
    this.props.scrollToForm();
  }

  renderButtons = () => {
    const { loading } = this.props;

    if (loading) {
      return (
        <img src={spinnerIcon} alt="loading" />
      );
    } else {
      return (
        <Fragment>
          <button
            className={(this.props.searchNumber.length < 8 || this.props.loading) ? 'btn btn-disabled disabled' : 'btn btn-disabled'}
            type="submit"
            disabled={this.props.searchNumber.length < 8 || this.props.loading}
          >
            <div data-id="estimate_value">{this.props.strings.btn1}</div>
          </button>
          <div
            className='btn btn-not_found'
            onClick={this.clickHandler}>
            <div data-id="not_found" id="not_found">{this.props.strings.forget}</div>
          </div>
        </Fragment>
      );
    }
  };

  render() {
    return (
      <div className={this.props.step === 1 ? 'kasco__default kasco__kasco_default kasco_item show' : 'kasco__default kasco__kasco_default kasco_item'}>
        <div className="flex">
          <div className="txt width-50">
            <h2>{this.props.strings.title1} <br />{this.props.strings.title2}</h2>
            <p>{this.props.strings.titleTxt}</p>
          </div>
          <div className="arrow">
            <svg width={126} height={32} viewBox="0 0 126 32" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fillRule="evenodd" clipRule="evenodd" d="M122.517 17.0001L0 17.0001V15.0001L122.518 15.0001L110.827 1.29812L112.349 0L125.446 15.3508L126 15.9998L125.446 16.6489L112.349 31.9997L110.827 30.7015L122.517 17.0001Z" fill="#788392" />
            </svg>
          </div>
          <div className="form width-50">
            <form onSubmit={this.props.findByNumber} ref={(ref) => this.props.getCarNumberFormRef(ref)}>
              <div className={this.props.focused ? 'form-group input-focus' : 'form-group'}>
                <input onFocus={this.props.focusInput} onBlur={this.props.blurInput} className="form-control" type="text" maxLength="8" placeholder="АА1234АА" id="input1" value={this.props.searchNumber} onChange={this.props.handleChange} />
                <svg width={283} height={80} viewBox="0 0 283 80" fill="none" className="input-bg">
                  <rect x={1} y={1} width={281} height={78} rx={3} fill="white" stroke="url(#inp)" strokeWidth={2} />
                  <defs>
                    <linearGradient id="inp" x1="141.5" y1={0} x2="141.5" y2={80} gradientUnits="userSpaceOnUse">
                      <stop stopColor="#1487CF">
                        <animate attributeName="stop-color" values="#1487CF; #FFD83A; #1487CF;" dur="3s" repeatCount="indefinite" />
                      </stop>
                      <stop offset="0.293" stopColor="#1487CF">
                        <animate attributeName="stop-color" values="#1487CF; #FFD83A; #1487CF;" dur="3s" repeatCount="indefinite" />
                      </stop>
                      <stop offset={1} stopColor="#FFD83A">
                        <animate attributeName="stop-color" values="#FFD83A;#1487CF;#FFD83A;" dur="3s" repeatCount="indefinite" />
                      </stop>
                    </linearGradient>
                  </defs>
                </svg>
                <div className="validation">{this.props.strings.needed}</div>
              </div>
              {this.renderButtons()}
            </form>
          </div>
        </div>
      </div>
    );
  }
}

export default SearchCarNumber;
